import { CornerDialog as DsCornerDialog } from '@routable/components';
import React from 'react';
import { callIfIsFn } from 'helpers/utility';
const CornerDialog = ({ children, onCloseComplete, ...rest }) => (React.createElement(DsCornerDialog, { className: "corner-dialog", onClose: () => callIfIsFn(onCloseComplete), ...rest }, children));
export default CornerDialog;
